"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkBook = void 0;
class WorkBook {
    constructor() {
        this.Sheets = {};
        this.SheetNames = [];
    }
}
exports.WorkBook = WorkBook;
